export const stringify = (value: any): string => {
  return JSON.stringify(value);
};

export function parse<T>(str: string): T {
  return JSON.parse(str) as T;
}
